import { useState } from 'react';

import { CasRenderDateTime, CasTable } from 'src/compass/shared/components';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import HubspotPollStatus from './HubspotPollStatus';
import PollingLogDetailsDialog from './PollingLogDetailsDialog';

/*
  What the HubSpot poll has changed (hubspot.PollingLog), newest first, under how far it has got -
  on Utilities > Customer Maintenance and on Administration > Integrations > Hubspot. The nightly
  import's changes are not here; only the poll's (its timer and Poll Now) - to companies, contacts,
  company contacts and deals. Who opens the change beside the record as the copy holds it now.
*/
export default function HubspotSyncTab() {
  const [logId, setLogId] = useState<number | null>(null);
  const { data: status } = useRetrieve({ url: 'Hubspot/PollingLog/Status' });

  return (
    <>
      {status && (
        <HubspotPollStatus
          lastRun={status.contactPollLastRun}
          watermark={status.contactPollWatermark}
          companyWatermark={status.companyPollWatermark}
          dealWatermark={status.dealPollWatermark}
        />
      )}

      <CasTable
        entity="Hubspot/PollingLog"
        update={null}
        defaultOrderBy="dateCreated"
        defaultOrder="desc"
        columns={[
          { field: 'dateCreated', label: 'When', render: CasRenderDateTime },
          { field: 'what' },
          {
            field: 'who',
            render: ({ row }: ICasRenderCellProps) => (
              <CasLink onClick={() => setLogId(row.id)}>{row.who || '(not in the copy)'}</CasLink>
            ),
          },
          { field: 'op' },
        ]}
        includeExport={false}
      />

      {logId && <PollingLogDetailsDialog id={logId} onClose={() => setLogId(null)} />}
    </>
  );
}
